import { FaArrowLeft, FaArrowRight, FaEyeSlash } from "react-icons/fa";
import { ArrowDirection } from "../../../../common/services/realtime/stimulus-types";
import { ArrowButton, ArrowControlsWrapper } from "./style";

export interface ArrowControlsProps {
    selected: ArrowDirection | null;
    onSelect: (direction: ArrowDirection) => void;
    onHide: () => void;
}

export const ArrowControls = ({ selected, onSelect, onHide }: ArrowControlsProps) => (
    <>
    <ArrowControlsWrapper role="toolbar">
        <ArrowButton
            type="button"
            aria-label="Seta para a esquerda"
            $selected={selected === ArrowDirection.LEFT}
            onClick={() => onSelect(ArrowDirection.LEFT)}
        >
            <FaArrowLeft aria-hidden />
        </ArrowButton>
        <ArrowButton type="button" aria-label="Esconder setas" title="Esconder setas" onClick={onHide}>
            <FaEyeSlash aria-hidden />
        </ArrowButton>
        <ArrowButton
            type="button"
            aria-label="Seta para a direita"
            $selected={selected === ArrowDirection.RIGHT}
            onClick={() => onSelect(ArrowDirection.RIGHT)}
        >
            <FaArrowRight aria-hidden />
        </ArrowButton>
    </ArrowControlsWrapper>
    </>
);
